import React from 'react';
import styled, { css } from 'styled-components';
import { greenColor, lightGrey3Color, blueColor } from 'js/config/style';

const statusStyle = {
  accepted_by_seller: css`
    color: ${blueColor};
  `,
  shipped_by_seller: css`
    color: ${blueColor};
  `,
  delivered_to_buyer: css`
    color: ${blueColor};
  `,
  order_completed: css`
    color: ${greenColor};
  `,
  default: css`
    color: ${lightGrey3Color};
  `,
};

const Container = styled.div`
  grid-area: status;
  align-self: center;
`;

const Display = styled.div`
  display: inline-block;
  font-size: 0.8rem;
  margin-top: 0.25rem;
  font-weight: 500;

  ${({ status }) => statusStyle[status] || statusStyle.default}
`;

export default ({ order }) => (
  <Container>
    <Display status={order.status}>{order.human_status}</Display>
  </Container>
);
